export default "__VITE_ASSET__DlpXm4_9__"